<template>
    <div class="title-section">
        <span class="title-section__title">{{ t('exports.conditionStatus.title') }}</span>
        <span class="title-section__subtitle">{{ pageSubtitle }}</span>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useGeneratorId } from '@/composables/useGeneratorId'
import { useGeneratorDetailsQuery } from '@/api/queries/generators/useGeneratorDetailsQuery'

const { t } = useI18n()

const generatorId = useGeneratorId()
const { data: generatorDetailsData } = useGeneratorDetailsQuery(generatorId)

const pageSubtitle = computed(() => {
    if (!generatorDetailsData.value) {
        return ''
    }

    const plantGroupName = generatorDetailsData.value.riverGroupName
    const plantName = generatorDetailsData.value.powerPlantName
    const generatorName = generatorDetailsData.value.name
    const generatorSid = generatorDetailsData.value.generatorID

    return `${plantGroupName} / ${plantName} / ${generatorName} / ${generatorSid}`
})
</script>

<style scoped lang="scss">
.title-section {
    color: $pbl-text;
    margin: $spacing-s $spacing-s;

    display: flex;
    flex-direction: column;
    gap: $spacing-3xs;

    &__title {
        font-weight: 500;
    }
}
</style>
